function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgVideoOn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 32,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    x: 1,
    y: 1,
    width: 19,
    height: 18,
    rx: 2,
    stroke: props.color,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M29.423 3.115l-8.225 5.816a1 1 0 00.029 1.652l8.224 5.4A1 1 0 0031 15.147V3.932a1 1 0 00-1.577-.817z",
    stroke: props.color,
    strokeWidth: 2
  }));
}

export default SvgVideoOn;